module.exports = __webpack_public_path__ + "static/media/check_green.260fd418.svg";